import { Button, CircularProgress, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";

import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteIcon from "@mui/icons-material/Delete";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";

const { REACT_APP_PDF_WORKER_SRC } = process.env;

function UploadCourseDoc(props) {
  const [file, setFile] = useState(null);
  const [numPages, setNumPages] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const fileData = localStorage.getItem("file");
    if (fileData) {
      setFile(fileData);
    }
  }, []);

  function onFileChange(event) {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = () => {
      // Store file data in localStorage
      localStorage.setItem("file", reader.result);
      setFile(file);
      setNumPages(null); // Reset numPages state when a new file is uploaded
    };

    reader.readAsDataURL(file);
  }

  function onRemoveClick() {
    setIsDeleting(true);
    // simulate file deletion delay for 2 seconds
    setTimeout(() => {
      setFile(null);
      localStorage.removeItem("file");
      setIsDeleting(false);
    }, 2000);
  }

  function onClick() {
    const file = localStorage.getItem("file");
    if (typeof file === "string") {
      const parts = file.split(",");
      const data = parts[1];
      const binaryData = atob(data);
      const arrayBuffer = new ArrayBuffer(binaryData.length);
      const uint8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < binaryData.length; i++) {
        uint8Array[i] = binaryData.charCodeAt(i);
      }
      const blob = new Blob([uint8Array], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");
    } else {
      console.log("File is not a string:", file);
    }
  }

  return (
    <Grid container spacing={2}>
      {file ? (
        <>
          <Grid item xs={12}>
            <div>
              <FontAwesomeIcon
                icon={faFilePdf}
                size="3x"
                style={{ color: "grey" }}
              />
            </div>
            <Button 
              onClick={onClick} 
              sx={{ 
                color: "#0047AB", 
                textDecoration: "underline" 
              }}
            >
              View Document
            </Button>
            <Button
              onClick={onRemoveClick}
              startIcon={<DeleteIcon />}
              sx={{
                minWidth: 'auto',
                backgroundColor: 'transparent',
                paddingBottom: "10px",
              }}
              color="secondary"
              disabled={isDeleting}
              title="Delete Course Document"
            >
              {isDeleting ? 'Deleting...' : ''}
            </Button>
            {isDeleting && <CircularProgress size={24} />}
          </Grid>
        </>
      ) : (
        <Grid item xs={12}>
          <input
            accept="application/pdf"
            type="file"
            onChange={onFileChange}
            style={{ display: "none" }}
            id="upload-pdf-button"
          />
          <label htmlFor="upload-pdf-button">
            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              startIcon={<CloudUploadIcon />}
              sx={{
                color: "white",
                borderRadius: "8px",
                padding: "10px 20px",
                boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)",
              }}
            >
              Upload Course Document
            </Button>
          </label>
        </Grid>
      )}
    </Grid>
  );
}

export default UploadCourseDoc;